<template>
  <div class="component-input-image" :class="{ slim: isSlim }">
    <div class="row">
      <div class="col-lg-12">
        <div :class="value ? '' : 'container-upload-image dashed-borders'">
          <!-- Upload -->
          <div class="upload-image" :class="{ 'd-none': value }">
            <div>
              <img src="@/assets/images/btn-stars.png" v-if="!isSlim" />
              <i class="icon-image" :class="{ 'mb-6 mb-lg-3': !isSlim }"></i>
            </div>
            <div class="text-primary font-weight-bold">
              {{ title }}
            </div>
            <div class="mt-3 mb-6 text-muted small-text">
              Arraste para cá ou selecione.
            </div>
            <div class="text-secondary small-text">
              <small>JPG/JPEG e PNG de até 5MB</small>
            </div>
            <div v-if="dimensions" class="text-secondary small-text">
              <small>Dimensões recomendadas: {{ dimensions }}</small>
            </div>

            <input
              :id="id"
              type="file"
              accept="image/*"
              class="input-file"
              @change="fileChange($event.target.files)"
            />
          </div>
          <!-- Success -->
          <div v-if="value" class="container-image">
            <img :src="value" />
            <button class="btn edit-image" type="button" @click="changeImage">
              <i class="fa-solid fa-pen"></i>
            </button>
            <button
              v-if="!hideDelete"
              class="btn remove-image"
              type="button"
              @click="resetImage"
            >
              <i class="icon-x"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="image-description mt-5 text-secondary"
      v-if="!isSlim && description"
    >
      <span class="small font-weight-bold">Dica: </span>
      <span class="text-secondary small-text">{{ description }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Imagem do Produto"
    },
    accepted_extensions: {
      type: Array,
      default: () => ["png", "jpg", "jpeg", "webp"]
    },
    description: {
      type: String
    },
    value: {
      type: [File, String],
      default: null
    },
    isSlim: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: "file-img"
    },
    dimensions: {
      type: String
    }
  },
  computed: {
    isValid() {
      let valid = false;
      for (const key in this.form) {
        valid = Array.isArray(this.form[key])
          ? this.form[key].length
          : !!this.form[key];
      }
      return valid;
    }
  },
  methods: {
    changeImage() {
      document.getElementById(this.id).click();
    },
    resetImage() {
      this.$emit("input", null);
      document.getElementById(this.id).type = "text";
      document.getElementById(this.id).type = "file";
    },
    getExtension(name) {
      const filename = `${name}`.toLowerCase();
      return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
    },
    fileChange(files) {
      if (!files || !files[0]) return;

      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = parseInt(Math.floor(Math.log(files[0].size) / Math.log(1024)));
      const size =
        Math.round(files[0].size / Math.pow(1024, i), 2) + " " + sizes[i]; // convert to mb and show unit meansurement

      if (size.match("MB") && /([^MB]*)MB/.exec(size)[1] > 5) {
        this.$message.error("O arquivo deve ter no máximo 5 mb");
        return;
      }

      if (
        !this.accepted_extensions.includes(this.getExtension(files[0].name))
      ) {
        this.$message.error(
          "O arquivo deve ter extensão .png, .jpg, .jpeg ou .webp"
        );
        return;
      }

      this.getImage(files[0]).then(img => {
        this.$emit("input", img);
      });
    },
    getImage(file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader();
        const img = document.createElement("img");

        fReader.onload = () => {
          img.src = fReader.result;
          resolve(this.getBase64Image(img));
        };

        fReader.readAsDataURL(file);
      });
    },
    getBase64Image(img) {
      const dataURL = img.src;
      return dataURL;
    }
  }
};
</script>
<style lang="scss" scoped>
.component-input-image {
  .upload-image {
    padding: 56px 16px 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    height: 100%;
    position: relative;

    img {
      position: absolute;
      left: 50%;
      top: 50px;
      transform: rotate(40deg) translate(-28px, 7px);
      width: 60px;
    }

    i {
      font-size: 56px;
      margin-bottom: 30px;
      color: #9155ec;
    }

    @media screen and (max-width: 991px) {
      padding: 26px 10px 22px;

      div {
        font-size: 12px;
      }

      i {
        font-size: 46px;
        margin-bottom: 10px;
        color: #9155ec;
      }
    }
  }

  .container-image {
    display: flex;
    justify-content: center;
    max-width: 100%;
    position: relative;

    @media screen and (min-width: 768px) {
      width: 272px;
    }

    img {
      max-width: 100%;
      border-radius: 4px;
      transition: filter 0.2s;

      @media screen and (max-width: 991px) {
        max-height: 100vw;
      }
    }

    .edit-image,
    .remove-image {
      opacity: 0.65;
      transition: opacity 0.2s;
      min-width: 24px;
      min-height: 24px;
      max-width: 24px;
      max-height: 24px;
      background-color: #393444;
      position: absolute;
      color: #fff;

      display: flex;
      justify-content: center;
      align-items: center;

      i {
        max-width: 24px;
      }
    }

    .edit-image {
      right: 15px + 6px + 26px + 6px;
      top: 8px;
    }
    .remove-image {
      right: 15px + 6px;
      top: 8px;
    }

    &:hover {
      img {
        filter: brightness(0.65);
      }

      .edit-image,
      .remove-image {
        opacity: 1;
      }
    }
  }

  .container-upload-image {
    height: 240px;
    width: 272px;
    max-width: 100%;
    @media screen and (max-width: 991px) {
      width: 100%;
    }
  }

  .image-description {
    line-height: 20px;
    width: 272px;
    max-width: 100%;
    @media screen and (max-width: 991px) {
      width: 100%;
    }
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100%;
    margin-bottom: 10%;
    position: absolute;
    cursor: pointer;
  }

  &.slim {
    .upload-image {
      padding: 12px 24px 9px;
      flex-direction: column;
      justify-content: flex-start;
      i {
        font-size: 24px;
        margin-bottom: 0px;
        margin-right: 10px;
      }
    }

    .text-primary {
      font-size: 14px;
    }
    .container-upload-image {
      height: fit-content;
      width: 100%;
    }

    .input-file {
      margin-bottom: 0;
      margin-left: -5%;
    }
  }
}
</style>
